export default __webpack_public_path__ + "static/INTEL-f5b3cba42843393ce38be24dc4fbdb6b.svg";